/* eslint-disable */
import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import MSectionCollection, { MSECTION_MODE_TAB, MSECTION_MODE_SECTION } from "components/Shared/MSectionCollection";
import { Button } from "react-md";
import * as yup from "yup";
import MCard from "components/Shared/MCard.tsx";
import {
  DATA_TYPE_MULTI_LINE_STRING,
  DATA_TYPE_NUMBER,
  DATA_TYPE_NUMBER_UNFORMATTED,
  DATA_TYPE_PHONE_NUMBER,
  DATA_TYPE_MONEY,
  DATA_TYPE_BOOLEAN,
  DATA_TYPE_DATE,
  DATA_TYPE_DATE_TIME,
  DATA_TYPE_TIME,
  DATA_TYPE_DAYS_ELAPSED,
  DATA_TYPE_DROPDOWN,
  DATA_TYPE_DROPDOWN2,
  DATA_TYPE_STRING,
  DATA_TYPE_CHECKBOX,
  DATA_TYPE_RADIO,
} from "typeConstants/dataTypes";
import { getVariableGridCellSize } from "components/Shared/Functions";
import MGridForm, {
  DISPLAY_STYLE_HEADER,
  DISPLAY_STYLE_SHADED,
  DISPLAY_STYLE_BOLD,
  DISPLAY_STYLE_CENTERED,
  DISPLAY_STYLE_LEFT,
  DISPLAY_STYLE_RIGHT,
  DISPLAY_STYLE_MULTI_CHECKBOX_NEW_LINES,
  DISPLAY_STYLE_RIGHT_ALIGN_STRING,
} from "../Shared/MGridForm";
import { getAppraisalFormData, setAppraisalFormData } from "actions/homeowner/caseforms";
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import Appraisal1004p from "../Homeowner/CaseForms/Appraisal1004P/Appraisal1004p";
import MSplitter from "../Shared/MSplitter.tsx";
import MSection, { UNMOUNT_STATUS_WARNING, UNMOUNT_STATUS_DISALLOW } from "../Shared/MSection.tsx";
import CompactHistory from "components/Homeowner/History/CompactHistory";
import CaseIssues from "components/Homeowner/FieldReps/CaseIssues";
import { Notifications } from "components/Homeowner/CaseForms/Validations";
import MCaseView from "../../containers/Homeowner/MCaseView";
import CaseHazards from "../QualityAssurance/Sections/Outline/CaseHazards";

class LukeTestPage extends Component {
  constructor(props) {
    super(props);

    this.mSectionControlMethods = null;
    this.YUP = this.YUP.bind(this);
    this.setMCardControlMethods = this.setMCardControlMethods.bind(this);
    this.changeCardCount = this.changeCardCount.bind(this);

    this.mcardControlMethods = null;
    this.modifiedFormData = null;
    this.changedFormFields = [];

    this.state = {
      cardCount: 7,
      formData: null,
      controlIdFor1004p: 13872384,
      shouldRenderGridForm: true,
    };
  }

  YUP() {
    let createUserSchema = yup.object({
      username: yup.string("ERROR").required(),
      emailAddress: yup.string("NOT A STRING").email("NOT AN EMAIL").required("REQUIRED"),
      intThanks: yup.number("MUST BE NUMBER").positive("MUST BE POSITIVE").integer("INTEGER")
    });

    try {
      createUserSchema.validateSync({
        username: "Username",
        emailAddress: 3,
        intThanks: -3.4
      }, { abortEarly: false });
    } catch (error) {
      window.console.log(error);
    }
  }

  setMCardControlMethods(cm) {
    this.mcardControlMethods = cm;
  }

  changeCardCount(amount) {
    let count = this.state.cardCount + amount;
    if (count < 1) count = 1;
    this.setState({ cardCount: count });
  }

  render() {
    return (
      <div className="padding-page-content full-height">
        <MSectionCollection
          defaultMode={MSECTION_MODE_TAB}
          tabModeCollapsible={false}
          fullHeight
          sections={[
            {
              title: "MCaseView", children:
                <MCaseView controlNumberOverride={8535794} />
            },
            {
              title: "case hazard", children:
                <CaseHazards />
            },
            {
              title: "horizontal splitter", children:
                <MSplitter
                  firstChild={<div style={{ width: "100%", height: "100%", backgroundColor: "green" }} />}
                  secondChild={<div style={{ width: "100%", height: "100%", backgroundColor: "blue" }} />}
                  secondChildTitle={{
                    title: "Field Rep Profile",
                    buttons: [
                      { icon: "fullscreen" },
                      { icon: "close" }
                    ]
                  }}
                  splitHorizontal
                />
            },
            {
              title: "Case Issues", children:
                <CaseIssues frNumber="25294" />
            },
            {
              title: "Tabbed History", children:
                <CompactHistory controlNumber="13934589" />
            },
            {
              title: "MSection Test", children:
                <MSection
                  canUnmountChildWarning="NO CAN DO"
                //canUnmountChildStatus={UNMOUNT_STATUS_DISALLOW}
                >
                  HELLO
                </MSection>
            },
            {
              title: "Splitter Test", children:
                <MSplitter
                  firstChild={<div style={{ width: "100%", height: "100%", backgroundColor: "green" }} />}
                  secondChild={<div style={{ width: "100%", height: "100%", backgroundColor: "blue" }} />}
                />
            },
            {
              title: "MGridForm test", children:
                <div>
                  <Appraisal1004p controlNumber="13872384" />
                </div>
            },
            {
              title: "MCard Validation Tests", children:
                <React.Fragment>
                  <Button onClick={this.YUP}>YUP</Button>
                  <Button onClick={() => window.console.log(this.mcardControlMethods.runValidation(true))}>Validate All Fields</Button>
                  <Button onClick={() => this.mcardControlMethods.clearValidationErrors()}>Clear validations</Button>
                  <Button onClick={() => window.console.log(this.mcardControlMethods.getEditedData())}>Get edited data</Button>
                  <MCard
                    title="Test Validation"
                    isEditable
                    startInEditMode
                    getControlMethods={this.setMCardControlMethods}
                    fields={[
                      { key: "F0", label: "Email String", value: "jordawsil.com", validation: yup.string().email("must be a freakin email dude cmon").required("email is required") },
                      { key: "F1", label: "Multi Line String", dataType: DATA_TYPE_MULTI_LINE_STRING, value: "multiline\nstring\ndude", validation: yup.string().required("DATA_TYPE_MULTI_LINE_STRING is required") },
                      { key: "F2", label: "Number", dataType: DATA_TYPE_NUMBER, value: 123, validation: yup.number().typeError("MUST BE NUMBAR").required("number is required") },
                      { key: "F3", label: "Unformatted Number", dataType: DATA_TYPE_NUMBER_UNFORMATTED, value: null, validation: yup.number().typeError("must be an unformatted number??").required("this is required") },
                      { key: "F5", label: "phone number", dataType: DATA_TYPE_PHONE_NUMBER, value: "7169577770", validation: yup.string().required("phone is requried") },
                      { key: "F6", label: "monies", dataType: DATA_TYPE_MONEY, value: null },
                      { key: "F7", label: "boolean", dataType: DATA_TYPE_BOOLEAN, value: false }, //cant really have validation
                      //these bottom few only need validation on creating new entries
                      { key: "F8", label: "date", dataType: DATA_TYPE_DATE, value: null, validation: yup.date().typeError("this required").required() },
                      { key: "F9", label: "date time", dataType: DATA_TYPE_DATE_TIME, value: new Date(), validation: yup.date().typeError("this required").required() },
                      { key: "F10", label: "time", dataType: DATA_TYPE_TIME, value: new Date(), validation: yup.date().typeError("this required").required() },
                      { key: "F11", label: "days elapsed", dataType: DATA_TYPE_DAYS_ELAPSED, value: new Date(), validation: yup.date().typeError("this required").required() },
                      {
                        key: "F12",
                        label: "dropdown",
                        dataType: DATA_TYPE_DROPDOWN,
                        value: { label: "ONE", value: 1 },
                        dataTypeOptions: { options: [{ label: "ONE", value: 1 }, { label: "TWO", value: 2 }, { label: "THREE", value: 3 }] },
                        validation: yup.string().typeError("this required").required("this required")
                      },
                      {
                        key: "F13",
                        label: "dropdown dos",
                        dataType: DATA_TYPE_DROPDOWN2,
                        dataTypeOptions: { options: [{ label: "ONE", value: 1 }, { label: "TWO", value: 2 }, { label: "THREE", value: 3 }, { label: "FOUR", value: 4 }, { label: "FIVE", value: 5 }, { label: "SIX", value: 6 }] },
                        value: null,
                      },
                    ]}
                  />
                </React.Fragment>
            },
            {
              title: "MSection Collection Test", children:
                <React.Fragment>
                  <Button onClick={() => this.mSectionControlMethods.switchTab(3)}>switch tab</Button>
                  <Button onClick={() => this.mSectionControlMethods.switchMode(MSECTION_MODE_SECTION)}>switch mode MSECTION_MODE_SECTION</Button>
                  <Button onClick={() => this.mSectionControlMethods.switchMode(MSECTION_MODE_TAB)}>switch mode MSECTION_MODE_TAB</Button>
                  <MSectionCollection
                    defaultMode={MSECTION_MODE_TAB}
                    getControlMethods={(cm) => this.mSectionControlMethods = cm}
                    sections={[
                      {
                        title: "Expander Test Expander Test Expander Test",
                        children: <div> testing content </div>
                      },
                      {
                        title: "Expander Test dos",
                        children: <div> testing <br /> content </div>
                      },
                      {
                        title: "Expander Test tres",
                        children: <div> 3 sdflkjhasdklfhsadkljfhsdklfhaskh fgkshjfglkas <br /> dkjlfhsadklfhsadklfhsklad <br /> <br /> sdfljhasdft </div>
                      },
                      {
                        title: "Long Expander Test IV",
                        children: <div> 4 sdflkjhasdklfhsadkljfhsdklfhaskh fgkshjfglkas <br /> dkjlfhsadklfhsadklfhsklad <br /> <br /> sdfljhasdft </div>
                      },
                      {
                        title: "Longer Expander Test 5",
                        children: <div> 5 sdflkjhasdklfhsadkljfhsdklfhaskh fgkshjfglkas <br /> dkjlfhsadklfhsadklfhsklad <br /> <br /> sdfljhasdft </div>
                      },
                      {
                        title: "Expander Test Six",
                        children: <div> 6 sdflkjhasdklfhsadkljfhsdklfhaskh fgkshjfglkas <br /> dkjlfhsadklfhsadklfhsklad <br /> <br /> sdfljhasdft </div>
                      }
                    ]}
                  />
                </React.Fragment>
            },
            {
              title: "Card Layout Test", children:
                <React.Fragment>
                  <Button onClick={() => this.changeCardCount(-1)}>-</Button>
                  <Button onClick={() => this.changeCardCount(1)}>+</Button>
                  <div className="md-grid">
                    {[...Array(this.state.cardCount)].map((_, i) => <MCard key={`card-${i}`} title={`Card ${i}`} fields={[{ label: "Field", value: "Value" }]} className={`md-cell md-cell--${getVariableGridCellSize(this.state.cardCount, i)}`} />)}
                  </div>
                </React.Fragment>

            }]}
        />
      </div >);
  }
}

LukeTestPage.propTypes = {
  getAppraisalFormData: PropTypes.func,
  setAppraisalFormData: PropTypes.func,
  isFetchingAppraisalFormData: PropTypes.bool,
  isSavingAppraisalFormData: PropTypes.bool,
  dataForAppraisalForm: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isFetchingAppraisalFormData: state.caseForms.isFetchingAppraisalFormData,
  isSavingAppraisalFormData: state.caseForms.isSavingAppraisalFormData,
  dataForAppraisalForm: state.caseForms.dataForAppraisalForm,
});

const mapDispatchToProps = (dispatch) => ({
  getAppraisalFormData(controlNumber) {
    dispatch(getAppraisalFormData(controlNumber));
  },
  setAppraisalFormData(controlNumber, modifiedData) {
    dispatch(setAppraisalFormData(controlNumber, modifiedData));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LukeTestPage);
